import { render, staticRenderFns } from "./addPassengers.vue?vue&type=template&id=1b014788&"
import script from "./addPassengers.vue?vue&type=script&lang=ts&"
export * from "./addPassengers.vue?vue&type=script&lang=ts&"
import style0 from "./addPassengers.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports